(() => {
  const header = document.querySelector('.p4x-site-header');
  if (header) {
    const sizeHeader = () => {
      const height = Math.ceil(header.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--theme-header-height', `${height}px`);
      document.documentElement.style.setProperty('--theme-sticky-header-height', `${height}px`);
    };
    sizeHeader();
    new ResizeObserver(sizeHeader).observe(header);
  }
  const closeMenus = (except) => document.querySelectorAll('.p4x-site-header details[open]').forEach((detail) => {
    if (detail !== except && !detail.contains(except)) detail.open = false;
  });
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.p4x-site-header summary');
    if (summary) closeMenus(summary.parentElement);
    else if (!event.target.closest('.p4x-site-header')) closeMenus();
    if (event.target.closest('.p4x-site-header a')) closeMenus();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const current = document.querySelector('.p4x-mobile-nav[open]') || document.activeElement.closest('.p4x-site-header details[open]');
      closeMenus();
      if (current) current.querySelector('summary').focus();
    }
  });
  const query = new URLSearchParams(window.location.search);
  document.querySelectorAll('.p4x-enquiry-form').forEach((form) => {
    const vehicle = form.querySelector('[data-p4x-vehicle]');
    if (vehicle && !vehicle.value && query.has('vehicle')) vehicle.value = query.get('vehicle').slice(0, 160);
    const request = form.querySelector('[name="contact[Request type]"]');
    const requestType = { gvm: 'GVM upgrade assessment', workshop: 'Workshop service or installation', build: 'Build planning', product: 'Product quote' }[query.get('request')];
    if (request && requestType) request.value = requestType;
    const gvmContext = form.querySelector('[data-p4x-gvm-context]');
    const updateGvmContext = () => { if (gvmContext) gvmContext.hidden = request?.value !== 'GVM upgrade assessment'; };
    updateGvmContext();
    if (request) request.addEventListener('change', updateGvmContext);
    const context = form.querySelector('[data-p4x-product-context]');
    if (context && query.get('product')) {
      context.hidden = false;
      form.querySelector('[data-p4x-product]').value = query.get('product').slice(0, 250);
      const options = form.querySelector('[data-p4x-options]');
      const choice = query.get('variant') || '';
      options.value = choice === 'Default Title' ? '' : choice.slice(0, 250);
      if (!options.value) { options.hidden = true; options.previousElementSibling.hidden = true; }
      const path = query.get('product_path') || '';
      if (/^\/products\/[a-z0-9-]+$/.test(path)) form.querySelector('[data-p4x-product-path]').value = path;
    }
  });
  const refreshEnquiryLinks = (scope, variant) => {
    scope.querySelectorAll('[data-p4x-product-enquiry]').forEach((link) => {
      const values = new URLSearchParams({request: 'product', product: link.dataset.productTitle, product_path: link.dataset.productPath});
      const title = variant ? variant.title : link.dataset.variantTitle;
      if (title && title !== 'Default Title') values.set('variant', title);
      link.href = `/pages/get-a-quote?${values.toString()}`;
    });
  };
  refreshEnquiryLinks(document);
  document.addEventListener('on:variant:change', (event) => {
    const scope = event.target.closest('.js-product');
    if (scope) refreshEnquiryLinks(scope, event.detail.variant || {title: event.detail.selectedOptions.filter(Boolean).join(' / ')});
  });
  window.addEventListener('pageshow', () => closeMenus());
  // Sync the custom header after the theme confirms a cart mutation.
  // Serialize refreshes and ignore stale responses when another change arrives.
  let cartVersion = 0;
  let cartRefreshPending = false;
  const refreshCartCount = async () => {
    if (!document.querySelector('[data-p4x-cart-count]')) return;
    cartVersion += 1;
    if (cartRefreshPending) return;
    cartRefreshPending = true;
    const version = cartVersion;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 10000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: controller.signal
      });
      if (!response.ok) throw new Error(`Cart refresh failed: ${response.status}`);
      const cart = await response.json();
      if (version !== cartVersion || !Number.isInteger(cart.item_count) || cart.item_count < 0) return;
      document.querySelectorAll('[data-p4x-cart-count]').forEach((badge) => {
        badge.textContent = String(cart.item_count);
        badge.hidden = cart.item_count === 0;
      });
      document.querySelectorAll('[data-p4x-cart-link]').forEach((link) => {
        link.setAttribute('aria-label', `${link.dataset.p4xCartLabel} (${cart.item_count})`);
      });
    } catch (error) {
      // Preserve the last confirmed count; the next cart or page event retries.
    } finally {
      window.clearTimeout(timeout);
      cartRefreshPending = false;
      if (version !== cartVersion) refreshCartCount();
    }
  };
  document.addEventListener('on:cart:add', refreshCartCount);
  document.addEventListener('on:cart:change', refreshCartCount);
  document.addEventListener('shopify:section:load', refreshCartCount);
  window.addEventListener('pageshow', refreshCartCount);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refreshCartCount();
  });
})();
